import type { Node } from 'slate';

import { Element } from 'slate';

import type { TableHeaderElement } from '@ui/MarkdownEditor/types';

export const rdmdType = 'tableRow';
export const type = 'table-header';
export const isTableHeader = (node: Node): node is TableHeaderElement => Element.isElementType(node, type);
